module.exports = __webpack_public_path__ + "static/media/mhubIcon.63bc3e2f.png";